import { NgModule } from '@angular/core';
import { LensComponent } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/components/lens/lens.component';
import { WebConsoleContainerModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/components/web-console-container/web-console-container.module';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    WebConsoleContainerModule
  ],
  declarations: [
    LensComponent
  ],
  exports: [
    LensComponent
  ]
})
export class LensModule {}
